import { RegistrationMarriageFormVM } from 'mutation/view-models/registration-marriage';
import { transformCivilStatus } from 'shell/utils/consult-person/request-transformer/marital-status/civil-status';
import { RequestRegistrationMarrige } from 'shell/models/register-marriage';
import { transformerRequestMarriageAnpr05Mutation } from './common-request-transformer';

export const transformerRequestRegistrationMarriageData = (
  values: RegistrationMarriageFormVM
): RequestRegistrationMarrige => {
  const matrimonio = transformerRequestMarriageAnpr05Mutation(values.marriage);

  const statoCivile = transformCivilStatus(values.civilStatus);

  return {
    matrimonio,
    statoCivile,
    generalitaPerRicerca: {
      codiceFiscale: {
        codFiscale: values.person?.fiscalCode || undefined,
      },
      ...(values.person?.generality || {}),
    },
    generalitaDaModificare: {
      generalita: values.person?.generality
        ? {
            ...(values.person?.generality || {}),
          }
        : null,
    },
    testataRichiesta: {
      dataDecorrenza: values.editDataControl?.dateValidity?.toFormat('yyyy-MM-dd') || undefined,
    },
    datiControllo: {
      tipoMutazione: ['12', '01'],
    },
  };
};
